import { authRoleAccess } from "auth/AuthRoleAccess";
import { lazy } from "react";

const InformationSearchView = lazy(() => import("./InformationSearchView.jsx"));
const CaseSingleCaseView = lazy(() => import("./CaseSingleCaseView.jsx"));

const InformationSearchViewRoutes = [
  {
    path: "/InformationSearchView",
    component: InformationSearchView,
    auth: authRoleAccess.information_search_view,
  },
  {
    path: "/information-search/cases/:id",
    component: CaseSingleCaseView,
    auth: authRoleAccess.information_search_view,
  },
];

export default InformationSearchViewRoutes;
